import { showErrorToast, showSuccessToast } from "../../shared/Toasts";

const GATEWAY_TIMEOUT_STATUSES = [502, 504];

const STAGED_MESSAGE = "Staged! Mapping tests initiated. Monitor in Publish Module.";

// Mirrors StageAnalysis in merge-backend's merge/blueprints/constants.py.
export enum StageAnalysis {
  AnalyzedBeforeStage = "ANALYZED_BEFORE_STAGE",
  CompiledCodeBlockFallback = "COMPILED_CODE_BLOCK_FALLBACK",
  DataflowAnalysisDisabled = "DATAFLOW_ANALYSIS_DISABLED",
}

const STAGE_ANALYSIS_MESSAGES: Record<StageAnalysis, string> = {
  [StageAnalysis.AnalyzedBeforeStage]: "Analyzed before staging.",
  [StageAnalysis.CompiledCodeBlockFallback]:
    "A code block's source is compiled in this environment, so the analyzer runs after staging.",
  [StageAnalysis.DataflowAnalysisDisabled]:
    "Dataflow analysis is turned off, so nothing was analyzed.",
};

/**
 * Says which analysis path a synchronous stage took. A missing stageAnalysis means the backend flag is off and
 * the stage used the existing path, which analyzes after staging.
 */
export const showStageSuccessToast = (
  stageAnalysis: StageAnalysis | undefined,
  isStagedVersionOpen: boolean
) => {
  const analysisMessage = stageAnalysis
    ? STAGE_ANALYSIS_MESSAGES[stageAnalysis] ?? ""
    : "The analyzer runs after staging.";
  const stagedMessage = isStagedVersionOpen
    ? STAGED_MESSAGE
    : `Staged the version you had open before. ${STAGED_MESSAGE}`;
  showSuccessToast(`${stagedMessage} ${analysisMessage}`.trim());
};

export const showStageErrorToast = (error: Response | undefined) => {
  if (!error) {
    showErrorToast(
      "The stage request did not complete. Reload to see whether this version was staged."
    );
    return;
  }
  error
    .json()
    .then((value: string | Record<string, any>) => {
      const errorMessage =
        typeof value === "string"
          ? value
          : Array.isArray(value?.non_field_errors)
          ? value.non_field_errors.join(", ")
          : value?.non_field_errors ?? "Unknown error occurred";

      showErrorToast(`Failed to stage this version. Error message: \n ${errorMessage}`);
    })
    .catch(() => {
      // The backend answers in JSON, so a non-JSON 502 or 504 came from the web server or load balancer cutting the
      // request off, and the stage may still have committed.
      showErrorToast(
        GATEWAY_TIMEOUT_STATUSES.includes(error.status)
          ? "The stage request timed out. Reload to see whether this version was staged."
          : "Failed to stage this version."
      );
    });
};
